import { useState } from 'react';
import classNames from 'classnames';
import close from '../../assets/images/close.png';
import styles from './EditDescriptionModal.module.css';
import { updateFundraiserApi } from "../../api/fundraisers";
import Button from '../Button.jsx';
import FormButton from "../form/FormButton";
import FormError from "../form/FormError";
import FormTextEditor from "../form/FormTextEditor";

const EditDescriptionModal = (props) => {
    const [formData, setFormData] = useState({
        description: props.fundraiser.description
    });
    const initialErrorObject = {
        description: false
    };
    const [errorObject, setErrorObject] = useState(initialErrorObject);
    const inputsMessagesErrorObject = {
        description: 'Description must be at least 200 characters long',
    };
    const [editDescriptionInProgress, setEditDescriptionInProgress] = useState(false);

    const checkDescriptionLength = () => {
		if(formData.description.length < 200){
			setErrorObject((prevState) => ({...prevState, description: inputsMessagesErrorObject.description}));
			return false;
		}
		return true;
	};

    const submit = async(event) => {
        event.preventDefault();
        setErrorObject(initialErrorObject);
        setEditDescriptionInProgress(true);
        if(!checkDescriptionLength()){
            setEditDescriptionInProgress(false);
            return;
        }
        const editDescriptionResponse = await updateFundraiserApi(props.fundraiser.id, 'description', formData.description);
        let body;
        try{
            body = await editDescriptionResponse.json();
        }
        catch(e){}
        if(editDescriptionResponse && editDescriptionResponse.ok){
            props.updateFundraiserDescription(body.data.change_history_id, formData.description);
            props.close();
        }
        else{
            const error = body?.error ? body.error : 'Update fundraiser description failed';
            setErrorObject((prevState) => ({...prevState, apiError: error}));
        }
        setEditDescriptionInProgress(false);
    };

    return (
        <div className={styles.modal}>
            <div className={styles.container}>
                <div className={styles.header}>
                    Edit description
                </div>
                <img className={styles.close} src={close} alt="Close" onClick={props.close}/>
                <form className={styles.form} onSubmit={submit}>
                    <FormTextEditor className={styles.textEditor} label="Description"
                                    placeholder="Describe your fundraiser. For example, what would the money be used for, who would benefit, what impact would it have, how would you measure it, and when might you see results?"
                                    value={formData.description} update={(event) => setFormData({...formData, description: event.target.value})}
                                    error={errorObject.description} required/>
                    {
                        errorObject.apiError && (
                            <FormError error={errorObject.apiError}/>
                        )
                    }
                    <div className={classNames(styles.buttons, {[styles.buttonsApiError]: errorObject.apiError})}>
                        <Button className={styles.button} text="Cancel" onClick={props.close}/>
                        <FormButton className={styles.button} style={{marginLeft: 'auto'}} text="Update" disabled={editDescriptionInProgress}/>
                    </div>
                </form>
            </div>
        </div>
    )
};

export default EditDescriptionModal;